




































import { PropType } from 'vue';
import { defineComponent, computed, toRefs, ref, onMounted } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData, AdgroupConfig, AdgroupListItem, CreateMode } from '@tt4b/ttam-enums';
import { StateEnum, useAdgroupBudgetValidate, useStdAccountStore, useStdAdgroupIs, useStore } from '@tt4b/ttam-hooks';
import Schedule from './index';
interface amLiteData {
  range: string;
  continuously: string;
  label: string;
}
const name = 'ttam-schedule-lite-compose';

export default defineComponent({
  name,
  components: {
    TtamScheduleLabel: Schedule.TtamScheduleLabel,
    TtamScheduleContinuousRadio: Schedule.TtamScheduleContinuousRadio,
    TtamScheduleDaterangeRadio: Schedule.TtamScheduleDaterangeRadio,
    TtamScheduleDaterangeTimepicker: Schedule.TtamScheduleDaterangeTimepicker,
    TtamScheduleTimezone: Schedule.TtamScheduleTimezone,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
      required: true,
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
      required: true,
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      default: () => ({}),
      required: true,
    },
    cboAdgroupList: {
      type: Array as PropType<AdgroupListItem[]>,
      default: () => [],
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
    amLiteData: {
      type: Object as PropType<amLiteData>,
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, adgroupConfig, cboAdgroupList, createMode } = toRefs(props);
    const { timezone } = useStdAccountStore();

    const { getStore, state } = useStore();
    const { run: getTimezoneList } = getStore(StateEnum.timezoneList);
    const timezoneList = computed(() => state[StateEnum.timezoneList].data?.value?.timezone_list ?? []);
    const scheduleRef = ref();
    const { isLiveAds } = useStdAdgroupIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });

    const _scheduleType = computed({
      get: () => props?.adgroupData?.scheduleType,
      set: v => {
        emit('type-change', v);
        scheduleRef.value.validate('change');
      },
    });

    const _scheduleTimerange = computed({
      get: () => [props?.adgroupData?.startTime, props?.adgroupData?.endTime],
      set: v => {
        if (v?.[0]) {
          emit('starttime-change', v[0]);
        }
        if (v?.[1]) {
          emit('endtime-change', v[1]);
        }
      },
    });

    const { endTimeDisabled } = Schedule.useDaterangeTimepickerPropsEndTimeDisabled({
      adgroupConfig,
    });

    const { startTimeDisabled } = Schedule.useDaterangeTimepickerPropsStartTimeDisabled({
      adgroupConfig,
    });

    const { disabled: continuousRadioDisabled } = Schedule.useContinuousRadioPropsDisabled({
      adgroupData,
      campaignData,
    });

    const { disabled: daterangeDisabled } = Schedule.useDaterangeRadioPropsDisabled({
      adgroupData,
      campaignData,
    });

    const { visible: dateRangeTimePickerVisible } = Schedule.useDaterangeTimepickerPropsVisible({
      adgroupData,
      campaignData,
    });

    const { visible: continuousTimePickerVisible } = Schedule.useContinuousTimepickerPropsVisible({
      adgroupData,
      campaignData,
    });

    const { timeRangeValidator } = useAdgroupBudgetValidate({
      campaignFormData: campaignData,
    });

    // TODO 依赖splittest
    const isSplitTestEnabled = ref(false);

    const { visible: shopliveTipsVisible } = Schedule.useShopliveTipsPropsVisible({
      adgroupData,
      campaignData,
    });

    const { visible: dstTipsVisible } = Schedule.useDstTipsPropsVisible({
      adgroupData,
      campaignData,
    });

    onMounted(() => {
      // 其实感觉这行代码比较冗余
      getTimezoneList();
    });

    return {
      name,
      isLiveAds,
      timezone,
      timezoneList,
      _scheduleType,
      scheduleRef,
      _scheduleTimerange,
      endTimeDisabled,
      startTimeDisabled,
      daterangeDisabled,
      continuousRadioDisabled,
      continuousTimePickerVisible,
      dateRangeTimePickerVisible,

      timeRangeValidator,
      isSplitTestEnabled,
      shopliveTipsVisible,
      dstTipsVisible,
    };
  },
});
